webpackJsonp([0],{

/***/ 17:
/***/ (function(module, exports, __webpack_require__) {

"use strict";


__webpack_require__(18);

/***/ }),

/***/ 18:
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ })

},[17]);


// WEBPACK FOOTER //
// js/newDetail.98a2fa.js